<div>
  <div class="card mt-3">
    <div class="card-header text-uppercase">
      Atuações e Definições - Administrador Fiduciário
    </div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-4">
          <label> Data de Liquidação </label>
          <input
            required
            type="text"
            class="form-control"
            data-cy="settlementDate"
            name="settlementDate"
            [(ngModel)]="settlementDate"
            [textMask]="{ mask: validator.dateMask, guide: false }"
            [disabled]="!keepEditable()"
            (change)="emitSettlementDate()"
          />
        </div>
        <div class="col-8">
          <label> Comentário </label>
          <input
            type="text"
            data-cy="fundName"
            class="form-control"
            name="fundName"
            maxlength="90"
            pattern="^(?!\s*$).+"
            [disabled]="!keepEditable()"
            [(ngModel)]="administratorAnnotation"
            (change)="emitAdministratorAnnotation()"
          />
        </div>
      </div>
      <app-attachment
        #attachment
        [ticketId]="ticketId"
        [filterByGroup]="fiduciGroup"
        [canEdit]="true"
        [keepEditableForAdminFiduci]="keepEditable()"
      >
      </app-attachment>
    </div>
  </div>
</div>
